"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.search");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _throttleDebounce = require("throttle-debounce");

var _Button = _interopRequireDefault(require("@icare/components/lib/Button"));

var _AdvanceResults = _interopRequireDefault(require("./AdvanceResults"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchBar = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchBar, _React$Component);

  var _super = _createSuper(SearchBar);

  function SearchBar(props) {
    var _this;

    _classCallCheck(this, SearchBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_onSearchChange", function (e) {
      e.preventDefault();

      _this.setState({
        searchShow: false,
        searchQuery: e.target.value
      });

      if (e.target.value.length > 3) {
        _this._handleResults();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleResults", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var resultQuery;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.props.header.search.searchService(_this.state.searchQuery);

            case 3:
              resultQuery = _context.sent;

              if (resultQuery && resultQuery.autocomplete) {
                _this.setState({
                  searchShow: true,
                  results: resultQuery
                });
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "_onSearchClicked", function (e) {
      e.preventDefault();
      window.location.href = "".concat(_this.props.header.search.searchPageUrl, "?q=").concat(encodeURI(_this.state.searchQuery));
    });

    _this.state = {
      searchShow: false,
      searchQuery: '',
      results: {
        autocomplete: [],
        total: 0
      }
    };
    _this._handleResults = (0, _throttleDebounce.debounce)(500, _this._handleResults);
    return _this;
  }

  _createClass(SearchBar, [{
    key: "render",
    value: function render() {
      var onClose = this.props.onClose;
      var _this$state = this.state,
          searchShow = _this$state.searchShow,
          results = _this$state.results,
          searchQuery = _this$state.searchQuery;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "global-search",
        role: "search",
        id: "global-search"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "l-padding"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this._onSearchClicked
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "ctrl-holder"
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "global-search-input"
      }, "Search"), /*#__PURE__*/_react.default.createElement("div", {
        className: "ctrl"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "vh"
      }, "Type a minimum of three characters then press UP or DOWN on the keyboard to navigate the autocompleted search results"), /*#__PURE__*/_react.default.createElement("div", {
        className: "text autocomplete has-button"
      }, /*#__PURE__*/_react.default.createElement("input", {
        name: "q",
        id: "global-search-input",
        className: "js-autocomplete-input text",
        type: "search",
        placeholder: "Type to search",
        onChange: this._onSearchChange
      }), /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        type: "submit",
        className: "search-submit",
        variant: _Button.default.Variant.PRIMARY,
        iconName: "search",
        iconOnly: true
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "vh"
      }, "Search button")), /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        className: "search-close",
        variant: _Button.default.Variant.PRIMARY,
        onClick: onClose,
        iconName: "close-thick",
        iconOnly: true
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "vh"
      }, "Close button"), "Close"), searchShow && /*#__PURE__*/_react.default.createElement("div", {
        id: "q-autocomplete-results",
        className: "autocomplete-results",
        tabIndex: "-1"
      }, /*#__PURE__*/_react.default.createElement(_AdvanceResults.default, {
        searchResults: results.autocomplete,
        totalResults: results.total,
        queryValue: searchQuery
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "autocomplete-results-footer"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        variant: _Button.default.Variant.PRIMARY,
        className: "is-small autocomplete-results-item",
        onClick: this._onSearchClicked
      }, "See all results")))), /*#__PURE__*/_react.default.createElement("div", {
        className: "status-msg"
      }))))));
    }
  }]);

  return SearchBar;
}(_react.default.Component);

exports.default = SearchBar;

_defineProperty(SearchBar, "propTypes", {
  header: _propTypes.default.object.isRequired,
  onClose: _propTypes.default.func.isRequired
});
//# sourceMappingURL=SearchBar.js.map